export default __webpack_public_path__ + "static/huwat_3-2-073df8d4687e6099974fa5a11311191d.jpg";